export default function reshapeProjectionResults(results) {
    const sectionMap = {};

    results.forEach((weekData, index) => {
        Object.entries(weekData).forEach(([sectionName, values]) => {
            // if (typeof values !== "object" || values === null) return;

            // Move forecasted volumes into `kpi` instead of `forecast_tertiary`
            if (["primary", "secondary", "tertiary"].includes(sectionName)) {
                if (!sectionMap["kpi"]) sectionMap["kpi"] = {};
                if (!sectionMap["kpi"][sectionName]) sectionMap["kpi"][sectionName] = [];
                sectionMap["kpi"][sectionName][index] = values;
                return;
            }

            if (typeof values !== "object" || values === null) return;

            // All other nested object sections (drivers, forecast_tertiary, inputs, etc.)
            if (!sectionMap[sectionName]) sectionMap[sectionName] = {};
            Object.entries(values).forEach(([k, v]) => {
                if (!sectionMap[sectionName][k]) sectionMap[sectionName][k] = [];
                sectionMap[sectionName][k][index] = v;
            });
        });
    });

    // console.log("sectionMap", sectionMap);
    return sectionMap;
}
